import { TruckIcon } from "@heroicons/react/24/outline";
import ShippingAddress, { addressFields } from "containers/PageCheckout/ShippingAddress";
import React,{ useMemo,useRef,useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { useUpdateBillingMutation } from "store/api/customersApi";
import { setUser } from "store/slices";
import { useUser } from "store/utils/hooks";
import CommonLayout from "./CommonLayout";

const AccountAddresses = ({ className = "" }: { className?: string }) => {
  const user = useUser();
  const [update, res] = useUpdateBillingMutation();
  const dispatch = useDispatch();
  const shippingAddressRef = useRef(null);
  const billAddressRef = useRef(null);
  const [tabActive, setTabActive] = useState<string | null>(null);
  const [saveError, setSaveError] = useState("");
  const {
    register,
    formState: { errors },
    getValues,
    reset,
    trigger,
  } = useForm<any>({
    defaultValues: useMemo(() => {
      return user;
    }, [user]),
  });

  const handleScrollToEl = (ref: React.RefObject<HTMLDivElement>) => {
    if (ref.current) {
      setTimeout(() => {
        ref.current?.scrollIntoView({ behavior: "smooth" });
      }, 80);
    }
  };
  async function saveAddress(prefixFields = "") {
    const fields = addressFields.map((field) => `${prefixFields}${field}`);
    const isValid = await trigger(fields);

    if (!isValid) return;

    setSaveError("");
    const values = getValues(fields);
    const address = Object.fromEntries(
      fields.map((field, index) => [field, values[index]])
    );
    const { schools, students, ...data } = { ...user, ...address };

    try {
      const response = await update(data).unwrap();
      dispatch(setUser(response.data));
      reset(response.data);
      setTabActive(null);
      toast.success("Dirección actualizada");
    } catch (error: any) {
      const message = error?.data?.message || "Error al actualizar la dirección";
      setSaveError(message);
      toast.error(message);
    }
  }
  return (
    <div className={`nc-AccountPage ${className}`} data-nc-id="AccountPage">
      <CommonLayout>
        <div className="space-y-10 sm:space-y-12">
          {/* HEADING */}
          <h2 className="text-2xl sm:text-3xl font-semibold">Tus Datos</h2>
          <div className="xl:grid xl:gap-4 xl:grid-cols-2">
            <form
              ref={shippingAddressRef}
              className="scroll-mt-24"
              noValidate
              onSubmit={(event) => {
                event.preventDefault();
                saveAddress();
              }}
            >
              <ShippingAddress
                title={"Dirección de facturación"}
                register={register}
                errors={errors}
                isActive={tabActive === "ShippingAddress"}
                onOpenActive={() => {
                  setSaveError("");
                  setTabActive(
                    tabActive === "ShippingAddress"
                      ? null
                      : "ShippingAddress"
                  );
                  handleScrollToEl(shippingAddressRef);
                }}
                saveButtonLabel="Guardar dirección"
                saveButtonType="submit"
                isSaving={res.isLoading}
                saveError={saveError}
              />
            </form>
            <form
              ref={billAddressRef}
              className="scroll-mt-24 max-xl:mt-8 mb-4"
              noValidate
              onSubmit={(event) => {
                event.preventDefault();
                saveAddress("shipping_");
              }}
            >
              <ShippingAddress
                icon={
                  <TruckIcon className="w-6 h-6 text-slate-700 dark:text-slate-400 mt-0.5" />
                }
                title={"Dirección de envío"}
                register={register}
                errors={errors}
                saveButtonLabel="Guardar dirección"
                saveButtonType="submit"
                isSaving={res.isLoading}
                prefixFields="shipping_"
                isActive={tabActive === "BillAddress"}
                onOpenActive={() => {
                  setSaveError("");
                  setTabActive(
                    tabActive === "BillAddress" ? null : "BillAddress"
                  );
                  handleScrollToEl(billAddressRef);
                }}
                saveError={saveError}
              />
            </form>
          </div>
        </div>
      </CommonLayout>
    </div>
  );
};

export default AccountAddresses;
